import PropTypes from "prop-types";
import React from "react";
import styles from "./RowCheckbox.scss";

export class RowCheckbox extends React.PureComponent {
  static propTypes = {
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
  };

  render() {
    const { checked, onChange } = this.props;

    return (
      <div className={styles.RowCheckbox}>
        <input type="checkbox" checked={checked} onChange={onChange} />
      </div>
    );
  }
}
